export const template1: SimpleProjectServiceAPI.ConfigurationDataDto = {
  root: '99e0deab-4cbc-4453-b606-3a57c5afabf6',
  storeId: '601a7ada65fb000bda0cfeb7',
  articles: [
    {
      id: '99e0deab-4cbc-4453-b606-3a57c5afabf6',
      number: '920006 1500',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: '9108fd47-eec3-488c-988d-7048bbfd4ce3',
      number: '927300 300/3',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
        {
          ralValue: 'RAL 7016',
          affectedMaterial: 'config_ral_secondary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      number: '928010 962',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: '194aefcf-e983-4dcc-b8e4-9558f3fd4a50',
      number: '927300 300/2',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
        {
          ralValue: 'RAL 7016',
          affectedMaterial: 'config_ral_secondary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: '4ad6394a-877f-4326-8515-8a461011c439',
      number: '928111 1500',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: '4a31ed7d-4e67-4a7e-b58d-837c763c2ac6',
      number: '928090 1500',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: '4d7b108e-137d-4477-b1b3-99c4f8b3e9c8',
      number: '928050 1500',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: '0f858f44-de34-4da2-b5b0-5cb07c702ea1',
      number: '928130 1500',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: '0a40b8da-f8b2-455a-bf46-54ed349b829e',
      number: '928170 2',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: '64d0d98e-301e-4288-a398-8af11d37cb39',
      number: '928178 1',
      colors: [],
      requiredLightingArticlesIds: [],
    },
    {
      id: 'c4df3475-87ba-42cc-a8bf-548c6689a8f2',
      number: '928170 2',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      number: '928175 1',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
  ],
  slots: [
    {
      id: '56e89ea7-bdbf-4b8e-b402-59d154a1a92c',
      type: 'PAIR',
      parentId: '99e0deab-4cbc-4453-b606-3a57c5afabf6',
      name: 'supportColumnBase',
      childId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
    },
    {
      id: 'f1834b64-7391-4ae7-aa7e-05fad32dd72f',
      type: 'SINGLE',
      parentId: '99e0deab-4cbc-4453-b606-3a57c5afabf6',
      name: 'structureDividerBase',
      xIndex: 0,
      alignment: null,
    },
    {
      id: 'f0d645f3-60f0-4f0e-adf8-5cb1b25a3454',
      type: 'SINGLE',
      parentId: '99e0deab-4cbc-4453-b606-3a57c5afabf6',
      name: 'structureDividerBase',
      xIndex: 1,
      alignment: null,
    },
    {
      id: '5b7a1a9e-8dae-4911-9c4f-28d87e51ef28',
      type: 'PAIR',
      parentId: '99e0deab-4cbc-4453-b606-3a57c5afabf6',
      name: 'supportColumnBaseCenter',
    },
    {
      id: '046c347a-366a-46d8-9db5-db6d2d60bcb5',
      type: 'LINE',
      parentId: '99e0deab-4cbc-4453-b606-3a57c5afabf6',
      name: 'tabletopSubstructure',
      children: [
        {
          id: '9108fd47-eec3-488c-988d-7048bbfd4ce3',
          position: 102,
        },
        {
          id: '194aefcf-e983-4dcc-b8e4-9558f3fd4a50',
          position: 0,
        },
      ],
      axis: 'X',
      length: 1420,
    },
    {
      id: '1130d95a-eeb7-4c38-be58-c9bc926fa4df',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'columnThreadedBushTop',
      xIndex: 2,
      alignment: 'left',
    },
    {
      id: '8b0903a3-7444-4bba-aafe-822eb3e94ae3',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'leftColumnSuspension',
      xIndex: 1,
      alignment: null,
    },
    {
      id: 'd1907ef1-8414-46cf-85a1-38394a7af374',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'leftColumnSuspension',
      xIndex: 3,
      alignment: null,
    },
    {
      id: '99183a1b-78fb-4d8e-b69c-b5e436ed3325',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'columnMediaModule',
      xIndex: 0,
      alignment: 'right',
    },
    {
      id: '1070745e-f286-4db0-ba99-2fe002bbef30',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'rightColumnSuspension',
      xIndex: 1,
      alignment: null,
    },
    {
      id: 'ddf82caf-4f93-42ee-a70a-6ab9d789c630',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'leftColumnSuspension',
      xIndex: 5,
      alignment: null,
    },
    {
      id: 'fa33f7bb-c290-41a6-8b54-542e9dcf01c8',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'leftColumnSuspension',
      xIndex: 7,
      alignment: null,
    },
    {
      id: 'bbf78417-d668-4074-a348-8f044973395b',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'rightColumnSuspension',
      xIndex: 10,
      alignment: null,
    },
    {
      id: '4511d887-a485-4028-a840-82b47aaf4e5e',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'leftColumnSuspension',
      xIndex: 2,
      alignment: null,
    },
    {
      id: '35d3bbbf-63e7-4083-9d8b-7c8e58496053',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'leftColumnSuspension',
      xIndex: 0,
      alignment: null,
    },
    {
      id: '87ea265e-3058-4008-a1b1-1a9e70dc1d66',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'leftColumnSuspension',
      xIndex: 11,
      alignment: null,
    },
    {
      id: 'd76048f3-46ee-4fc9-a24f-cd1f085f87b1',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'rightColumnSuspension',
      xIndex: 0,
      alignment: null,
    },
    {
      id: '52395c74-4954-4e0e-b71b-f6d535fcea57',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'columnMediaModule',
      xIndex: 0,
      alignment: 'left',
    },
    {
      id: 'df2d6040-841b-4916-8fad-b44da366f46a',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'rightColumnSuspension',
      xIndex: 13,
      alignment: null,
    },
    {
      id: 'c6ffa8eb-1dd7-45b3-b6d8-390cc809d295',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'rightColumnSuspension',
      xIndex: 11,
      alignment: null,
    },
    {
      id: 'cff87688-012b-4d6f-bf8d-78722e602fd0',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'leftColumnSuspension',
      xIndex: 17,
      alignment: null,
    },
    {
      id: '0d6c8815-8db4-4cd4-bc22-a79e21cd1521',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'leftColumnSuspension',
      xIndex: 15,
      alignment: null,
    },
    {
      id: '7bb02473-2cd9-4ced-99e8-b85ed1643ce0',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'columnThreadedBushTop',
      xIndex: 1,
      alignment: 'left',
    },
    {
      id: '75229e7f-0826-4246-a45a-6a7553c14446',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'columnThreadedBushTop',
      xIndex: 2,
      alignment: 'right',
    },
    {
      id: '0499fc08-3156-4dcb-873f-7872c4a65148',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'rightColumnSuspension',
      xIndex: 2,
      alignment: null,
    },
    {
      id: '9c6c324e-2820-4387-a5f4-bd7ba4242492',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'columnMediaModule',
      xIndex: 1,
      alignment: 'right',
    },
    {
      id: '36810e10-95cd-41de-8acb-62863dd12957',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'rightColumnSuspension',
      xIndex: 15,
      alignment: null,
    },
    {
      id: '4fdd96af-725f-4fec-8c36-a3f3a1eec798',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'columnThreadedBushBottom',
      xIndex: 0,
      alignment: 'left',
    },
    {
      id: '0a2a9edb-1430-415d-8693-0c929c432011',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'rightColumnSuspension',
      xIndex: 7,
      alignment: null,
    },
    {
      id: 'b8907cf1-6411-401c-8aa3-e77fe081d44a',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'leftColumnSuspension',
      xIndex: 6,
      alignment: null,
    },
    {
      id: 'c1d59592-8eb1-4970-8b19-f583c2d95c1b',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'leftColumnSuspension',
      xIndex: 4,
      alignment: null,
    },
    {
      id: 'a9f966f6-b5d5-4348-9139-cfc259a224f8',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'rightColumnSuspension',
      xIndex: 16,
      alignment: null,
    },
    {
      id: '80f8d36c-376d-4b43-bf9b-0e909eeeaeb6',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'columnMediaModule',
      xIndex: 1,
      alignment: 'left',
    },
    {
      id: '6c0c1d9c-8e90-40fa-8e24-afb09a030bfa',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'columnThreadedBushTop',
      xIndex: 1,
      alignment: 'right',
    },
    {
      id: '78f1b5f0-f5c1-4d7a-aa06-ae53fe5089b3',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'leftColumnSuspension',
      xIndex: 14,
      alignment: null,
    },
    {
      id: 'f5777dd6-8ef8-4466-a0ab-c92b4f1c9145',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'columnThreadedBushTop',
      xIndex: 0,
      alignment: 'left',
    },
    {
      id: 'dc1b5506-a18f-4e27-a424-8c2937aebeaa',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'leftColumnSuspension',
      xIndex: 10,
      alignment: null,
    },
    {
      id: '909bc69b-c5ef-462e-9290-ad7546b1364a',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'rightColumnSuspension',
      xIndex: 12,
      alignment: null,
    },
    {
      id: 'e21cbd6e-7df6-42c9-a5d9-6cff52da2abb',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'rightColumnSuspension',
      xIndex: 17,
      alignment: null,
    },
    {
      id: 'f1c47661-d0a4-4a84-88da-43c700d1b629',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'leftColumnSuspension',
      xIndex: 12,
      alignment: null,
    },
    {
      id: '6cf34778-bbb0-4d98-a0fa-7b59cd5ed857',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'leftColumnSuspension',
      xIndex: 16,
      alignment: null,
    },
    {
      id: 'fed41c35-ece1-4afe-900e-4b7ce3078216',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'rightColumnSuspension',
      xIndex: 14,
      alignment: null,
    },
    {
      id: '8b8a4eed-8b32-4a95-914d-ccec31df8cf4',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'columnThreadedBushBottom',
      xIndex: 0,
      alignment: 'right',
    },
    {
      id: '77239b79-f115-40a3-8359-639643ce35a9',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'columnThreadedBushTop',
      xIndex: 0,
      alignment: 'right',
    },
    {
      id: '4db6b377-3cd0-4301-8750-5ed913b84cfd',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'leftColumnSuspension',
      xIndex: 13,
      alignment: null,
    },
    {
      id: '38a7836a-c780-4258-b5fd-590fcc171a7a',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'rearPanel',
      childId: '4ad6394a-877f-4326-8515-8a461011c439',
      xIndex: 0,
      alignment: null,
    },
    {
      id: 'c9be3c8f-2f50-4e58-9fd3-cc7ef4d6a6d4',
      type: 'PAIR',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      blockedBy: '4ad6394a-877f-4326-8515-8a461011c439',
      name: 'kanbanBase',
    },
    {
      id: '65e0d3c0-c389-4d1c-ad16-39c07f48d14c',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'rearPanel',
      childId: '4a31ed7d-4e67-4a7e-b58d-837c763c2ac6',
      xIndex: 1,
      alignment: null,
    },
    {
      id: 'a4b7c500-d83c-4736-842e-73a9be5ee576',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'columnTop',
      childId: '4d7b108e-137d-4477-b1b3-99c4f8b3e9c8',
      alignment: null,
    },
    {
      id: 'd41a7195-6d51-4df6-985d-43d8b00b0e7d',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'leftColumnSuspension',
      childId: '0f858f44-de34-4da2-b5b0-5cb07c702ea1',
      xIndex: 9,
      alignment: null,
    },
    {
      id: '68eb24e7-0009-447b-9e57-b52160d9c2cc',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      blockedBy: '0f858f44-de34-4da2-b5b0-5cb07c702ea1',
      name: 'rightColumnSuspension',
      xIndex: 9,
      alignment: null,
    },
    {
      id: '7abdf653-1c0e-4974-9edc-1c0e60b2a482',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      blockedBy: '0f858f44-de34-4da2-b5b0-5cb07c702ea1',
      name: 'leftColumnSuspension',
      xIndex: 8,
      alignment: null,
    },
    {
      id: 'a5bf4f4d-94a6-4a9a-9ed7-c986c51880ab',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      blockedBy: '0f858f44-de34-4da2-b5b0-5cb07c702ea1',
      name: 'rightColumnSuspension',
      xIndex: 8,
      alignment: null,
    },
    {
      id: '856173c4-7f10-4909-b60f-2a3922d9ccb3',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'columnThreadedBushBottom',
      childId: '0a40b8da-f8b2-455a-bf46-54ed349b829e',
      xIndex: 2,
      alignment: 'right',
    },
    {
      id: '22c408c8-b01e-44d6-bf78-27342333919c',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      blockedBy: '0a40b8da-f8b2-455a-bf46-54ed349b829e',
      name: 'rightColumnSuspension',
      xIndex: 3,
      alignment: null,
    },
    {
      id: 'a32f7c90-85ad-40f8-982e-b6cd4c3ac832',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      blockedBy: '0a40b8da-f8b2-455a-bf46-54ed349b829e',
      name: 'rightColumnSuspension',
      xIndex: 5,
      alignment: null,
    },
    {
      id: '265dc787-8a89-421a-b608-7db850173673',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      blockedBy: '0a40b8da-f8b2-455a-bf46-54ed349b829e',
      name: 'rightColumnSuspension',
      xIndex: 4,
      alignment: null,
    },
    {
      id: '28d97aaf-5ef0-4771-9ab4-3a6bdb308808',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      blockedBy: '0a40b8da-f8b2-455a-bf46-54ed349b829e',
      name: 'rightColumnSuspension',
      xIndex: 6,
      alignment: null,
    },
    {
      id: '2f2e1333-8255-4036-a920-6cc2e9e01cd7',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      blockedBy: '0a40b8da-f8b2-455a-bf46-54ed349b829e',
      name: 'columnThreadedBushBottom',
      xIndex: 1,
      alignment: 'right',
    },
    {
      id: 'eeaf4f94-e7fd-4023-ab6f-4cfd82db13d2',
      type: 'SINGLE',
      parentId: '0a40b8da-f8b2-455a-bf46-54ed349b829e',
      name: 'swivelArm',
      childId: '64d0d98e-301e-4288-a398-8af11d37cb39',
      alignment: null,
    },
    {
      id: '0794355a-4aa0-49d6-ace1-c4695ef51fa7',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      name: 'columnThreadedBushBottom',
      childId: 'c4df3475-87ba-42cc-a8bf-548c6689a8f2',
      xIndex: 2,
      alignment: 'left',
    },
    {
      id: '6072bc7e-5b0f-4ab4-aae9-2742190e3915',
      type: 'SINGLE',
      parentId: 'bccced98-f15b-4f05-8504-80b8c6e8f32b',
      blockedBy: 'c4df3475-87ba-42cc-a8bf-548c6689a8f2',
      name: 'columnThreadedBushBottom',
      xIndex: 1,
      alignment: 'left',
    },
    {
      id: '962ef633-b2c7-466f-a832-8b8749c381ed',
      type: 'SINGLE',
      parentId: 'c4df3475-87ba-42cc-a8bf-548c6689a8f2',
      name: 'swivelArm',
      childId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      alignment: null,
    },
    {
      id: '6999521c-9b6f-4435-a5a9-fd8ea4ce1255',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 8,
      yIndex: 9,
      alignment: null,
    },
    {
      id: '1d25e122-e110-4307-a4a7-b3fc850c3caf',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 4,
      yIndex: 4,
      alignment: null,
    },
    {
      id: '7f260cd5-f850-4734-b8e5-036ef1c5257f',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 0,
      yIndex: 10,
      alignment: null,
    },
    {
      id: 'cd258df5-1541-46b2-8f9e-a5efefe695a7',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 6,
      yIndex: 7,
      alignment: null,
    },
    {
      id: 'f94395d4-4157-4e4d-818c-0309774f6ad5',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 2,
      yIndex: 1,
      alignment: null,
    },
    {
      id: '573f4004-6e57-4dbe-8c80-910ee761a13c',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 3,
      yIndex: 9,
      alignment: null,
    },
    {
      id: 'e11f1e26-d501-49aa-b6bc-e4551eece16a',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 10,
      yIndex: 2,
      alignment: null,
    },
    {
      id: '8044a0c6-5134-46a2-a8f8-1d84ec8ec78f',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 0,
      yIndex: 4,
      alignment: null,
    },
    {
      id: 'bc429168-cddd-41c2-8497-4766594c9c13',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 10,
      yIndex: 8,
      alignment: null,
    },
    {
      id: '5e30409a-00aa-48c8-bf22-7e66cbffb7b1',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 12,
      yIndex: 1,
      alignment: null,
    },
    {
      id: '634eef1b-0486-430e-9c90-3e4b04afd8cd',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 1,
      yIndex: 7,
      alignment: null,
    },
    {
      id: 'f1f360c3-493a-4409-a812-1fb0a40c6524',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 9,
      yIndex: 8,
      alignment: null,
    },
    {
      id: '85a9c2ba-bb31-45dd-8b51-010c3c7ebedf',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 10,
      yIndex: 3,
      alignment: null,
    },
    {
      id: '9b138518-767b-4c38-ad61-d1bf215e9e27',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 11,
      yIndex: 7,
      alignment: null,
    },
    {
      id: 'b67bdc12-cfad-4ea8-8403-5518e7c40adb',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 12,
      yIndex: 6,
      alignment: null,
    },
    {
      id: 'a860d83a-cee8-4d32-9aa7-534a3be1fa1d',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 8,
      yIndex: 1,
      alignment: null,
    },
    {
      id: 'bae1cc96-3b34-46a6-8b75-c7c27e7f9273',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 1,
      yIndex: 10,
      alignment: null,
    },
    {
      id: '906bcf80-792e-44ae-ad17-6102d48b19c5',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 6,
      yIndex: 4,
      alignment: null,
    },
    {
      id: '191be732-dee2-4469-ba72-19222f4da981',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 6,
      yIndex: 5,
      alignment: null,
    },
    {
      id: 'ddecaf1f-7387-4725-bd49-97758ed26efb',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 2,
      yIndex: 8,
      alignment: null,
    },
    {
      id: '447586f3-52f5-42a4-a60f-ceb857eca699',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 0,
      yIndex: 7,
      alignment: null,
    },
    {
      id: 'a7a6c8a6-22e1-445e-97ab-26abf5de99ea',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 12,
      yIndex: 0,
      alignment: null,
    },
    {
      id: '638911bb-e6e6-4938-8602-c9249bd4e04b',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 3,
      yIndex: 3,
      alignment: null,
    },
    {
      id: '7b614d04-b37a-49f7-a22d-03328e1eef1f',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 6,
      yIndex: 10,
      alignment: null,
    },
    {
      id: 'bc51c959-1b09-4af5-87fe-3576667db3ea',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 2,
      yIndex: 2,
      alignment: null,
    },
    {
      id: '63d79f52-4cc2-4e83-905a-bf07668033a9',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 9,
      yIndex: 7,
      alignment: null,
    },
    {
      id: '5afbb133-7103-4ba6-87f7-2e583f953cfa',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 6,
      yIndex: 2,
      alignment: null,
    },
    {
      id: 'c1f26b39-9258-47b9-a3bc-7d32c499b0a6',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 3,
      yIndex: 8,
      alignment: null,
    },
    {
      id: 'ab31d18a-696e-452f-bfdd-d12fcfbab02c',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 5,
      yIndex: 4,
      alignment: null,
    },
    {
      id: '31b9c864-caac-4575-853d-d99c4a946f4e',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 1,
      yIndex: 2,
      alignment: null,
    },
    {
      id: 'e111688c-864b-452e-b41c-6889cbcc2543',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 3,
      yIndex: 0,
      alignment: null,
    },
    {
      id: 'ee811702-c3f5-461b-b71f-e56d482a34b9',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 11,
      yIndex: 4,
      alignment: null,
    },
    {
      id: '48c407ed-7bce-4e29-bd16-5c09f9d3460a',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 11,
      yIndex: 9,
      alignment: null,
    },
    {
      id: '737532c4-4bcd-4dc2-b1e9-9af187d146cb',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 7,
      yIndex: 8,
      alignment: null,
    },
    {
      id: '43b81a68-eed2-4323-ae15-405fe42f8f03',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 10,
      yIndex: 4,
      alignment: null,
    },
    {
      id: '46f050d9-fc34-48c7-a04c-aa822f46531f',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 0,
      yIndex: 9,
      alignment: null,
    },
    {
      id: '9dfdeca6-8ef3-4520-9241-39271b0d54e2',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 7,
      yIndex: 4,
      alignment: null,
    },
    {
      id: 'bed11d7c-ceee-4ee4-9369-4c43f2f9756c',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 12,
      yIndex: 8,
      alignment: null,
    },
    {
      id: 'a2c1d183-0aa2-4fb2-97d6-ccfea2529722',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 9,
      yIndex: 10,
      alignment: null,
    },
    {
      id: 'c81081ac-4f56-44b4-a6de-baf543faabad',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 11,
      yIndex: 1,
      alignment: null,
    },
    {
      id: '9a0f5798-e2a5-43d9-9b33-3f4e5dbcd195',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 3,
      yIndex: 7,
      alignment: null,
    },
    {
      id: 'df21480b-1147-4f18-89bf-117b52bff2ab',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 4,
      yIndex: 8,
      alignment: null,
    },
    {
      id: '34576b93-e944-4471-b5f2-68ca863f63cf',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 9,
      yIndex: 4,
      alignment: null,
    },
    {
      id: '5f57abbd-48e5-4926-8dd1-de2ffdbd8d80',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 11,
      yIndex: 6,
      alignment: null,
    },
    {
      id: '72de675f-e61a-4f8e-8884-1cdff08182dc',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 9,
      yIndex: 0,
      alignment: null,
    },
    {
      id: 'f9ca173a-eb65-46e2-8d65-9081dbdcefa3',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 3,
      yIndex: 2,
      alignment: null,
    },
    {
      id: 'e5d56d16-bc51-4b7a-b36f-fe3814e0e439',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 1,
      yIndex: 5,
      alignment: null,
    },
    {
      id: 'e6d28343-91da-44f2-92d9-2442c9cdefc4',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 7,
      yIndex: 2,
      alignment: null,
    },
    {
      id: 'f0036c1a-decb-476f-bfc9-9dd6d3fab553',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 2,
      yIndex: 6,
      alignment: null,
    },
    {
      id: '6a9f0859-f407-41d7-a391-1e6ea23e5277',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 3,
      yIndex: 10,
      alignment: null,
    },
    {
      id: '56292a2c-0ef0-4e1a-b4cc-73f31a55d344',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 12,
      yIndex: 5,
      alignment: null,
    },
    {
      id: '57f0c708-2931-4173-89ca-1054f0e08c06',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 8,
      yIndex: 7,
      alignment: null,
    },
    {
      id: '781be577-510d-494d-b053-daf706ced1df',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 2,
      yIndex: 4,
      alignment: null,
    },
    {
      id: 'eca1c309-cab7-4870-8d99-050eef1ac8d0',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 0,
      yIndex: 0,
      alignment: null,
    },
    {
      id: '72ad0d65-ed2c-4e1b-a0ed-b85c38422c1b',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 8,
      yIndex: 0,
      alignment: null,
    },
    {
      id: '64e7ac8c-f90f-44ed-a59d-ab53ee53460f',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 7,
      yIndex: 3,
      alignment: null,
    },
    {
      id: '7f7b063e-87cd-4066-a4b6-68f79adb83d1',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 9,
      yIndex: 9,
      alignment: null,
    },
    {
      id: 'ede0e174-869e-43c7-9f7c-e006bb9283b8',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 7,
      yIndex: 5,
      alignment: null,
    },
    {
      id: '882f841c-b0bf-4f0b-9498-42e59bc2b078',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 3,
      yIndex: 6,
      alignment: null,
    },
    {
      id: '7202295a-6266-4a43-83fb-670cf9a6d65f',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 2,
      yIndex: 5,
      alignment: null,
    },
    {
      id: '8805c48a-1499-477e-97e8-ce8c15de7186',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 9,
      yIndex: 1,
      alignment: null,
    },
    {
      id: 'e94b791f-13cb-42a9-8a94-66bceaa74637',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 2,
      yIndex: 10,
      alignment: null,
    },
    {
      id: '74a50f27-4bd5-48ad-a2b5-a39724a3bf89',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 9,
      yIndex: 2,
      alignment: null,
    },
    {
      id: 'c612a931-05b0-4414-beac-ef1d64e68abe',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 3,
      yIndex: 1,
      alignment: null,
    },
    {
      id: '3584f6e1-6ec4-4178-8888-1b329f852c7b',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 7,
      yIndex: 0,
      alignment: null,
    },
    {
      id: 'a57f6996-9925-484f-87bd-310c7f44bfb0',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 11,
      yIndex: 0,
      alignment: null,
    },
    {
      id: '3acbaccd-aa4a-423c-9ba1-12490c496c3b',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 7,
      yIndex: 7,
      alignment: null,
    },
    {
      id: '7830ca7a-deab-4c1c-ac3e-ad217ea0a922',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 8,
      yIndex: 10,
      alignment: null,
    },
    {
      id: '4650530a-a5a5-4d06-828c-8987805946fa',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 7,
      yIndex: 9,
      alignment: null,
    },
    {
      id: '70bd5e85-7666-43b1-8f36-f2f60e25b289',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 11,
      yIndex: 5,
      alignment: null,
    },
    {
      id: '8837244a-20c5-443f-bd2f-a98a71a98663',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 12,
      yIndex: 10,
      alignment: null,
    },
    {
      id: '379ea51b-77c2-4004-9ab3-bafe1848a53f',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 0,
      yIndex: 5,
      alignment: null,
    },
    {
      id: '33b25dd2-592f-4bc6-9ff6-f24606daf914',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 8,
      yIndex: 4,
      alignment: null,
    },
    {
      id: '89cb6adc-25ef-4aab-b1db-4aaf225643cc',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 10,
      yIndex: 10,
      alignment: null,
    },
    {
      id: '853995a2-6745-4b13-8fe3-e5eaffed27fe',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 4,
      yIndex: 9,
      alignment: null,
    },
    {
      id: 'bf48b61f-eca9-4538-8fce-d17f3cdf7346',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 1,
      yIndex: 9,
      alignment: null,
    },
    {
      id: 'dde47ae8-95a8-4848-b9d8-3521d55b51f9',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 10,
      yIndex: 7,
      alignment: null,
    },
    {
      id: 'a04faf36-dea2-4a5f-be5b-9dd3d76333c3',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 10,
      yIndex: 1,
      alignment: null,
    },
    {
      id: '3d8a259c-0c6c-4bba-9f12-d52185b1bc34',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 11,
      yIndex: 8,
      alignment: null,
    },
    {
      id: 'cc0ed176-9db9-47a2-91ac-02b4f81027d4',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 9,
      yIndex: 6,
      alignment: null,
    },
    {
      id: '142a4091-8178-41ee-ae55-2770d6f1e19c',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 5,
      yIndex: 8,
      alignment: null,
    },
    {
      id: '16736b41-1d55-4610-9c90-df714d21d4dc',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 5,
      yIndex: 3,
      alignment: null,
    },
    {
      id: '63927973-8907-401e-964a-946937c72317',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 2,
      yIndex: 3,
      alignment: null,
    },
    {
      id: '895b2960-94e3-4e45-82a5-8363ff836e74',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 4,
      yIndex: 2,
      alignment: null,
    },
    {
      id: 'cdbbbb82-7682-4e29-94eb-e8d09251774f',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 5,
      yIndex: 5,
      alignment: null,
    },
    {
      id: '30b653e4-10e0-419a-8f22-11be2743926a',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 1,
      yIndex: 4,
      alignment: null,
    },
    {
      id: '9ee24922-b5ca-4f67-a79c-13e6000593f6',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 5,
      yIndex: 10,
      alignment: null,
    },
    {
      id: '6dbf3e2f-942e-4a2d-946c-8bf3b3b76fc6',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 4,
      yIndex: 1,
      alignment: null,
    },
    {
      id: '6eeac28d-6395-4a46-b18a-35ab7e3cf2fc',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 6,
      yIndex: 6,
      alignment: null,
    },
    {
      id: '4d0cb496-d146-4b4c-b463-9bc8fcf95f48',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 1,
      yIndex: 1,
      alignment: null,
    },
    {
      id: '84c1b64d-a408-4607-853f-d824ff9b8a6e',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 6,
      yIndex: 3,
      alignment: null,
    },
    {
      id: '21c0f7d6-defa-416f-946c-78fa7f4dd39e',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 10,
      yIndex: 0,
      alignment: null,
    },
    {
      id: 'ccd7c3bf-bca0-4e73-a06b-3a04bc070990',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 11,
      yIndex: 3,
      alignment: null,
    },
    {
      id: '8dbe3f75-0b76-4aa3-bee8-d07775ddc776',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 0,
      yIndex: 1,
      alignment: null,
    },
    {
      id: 'be1c2c8c-33b6-4e4c-a1ce-16d00a9dc321',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 4,
      yIndex: 0,
      alignment: null,
    },
    {
      id: '0cc1680c-bfc7-44d8-ab8b-5d638ad3fcee',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 2,
      yIndex: 7,
      alignment: null,
    },
    {
      id: 'cf4c95f0-912f-4d50-ac17-bded697a6c69',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 6,
      yIndex: 9,
      alignment: null,
    },
    {
      id: 'ad9210ec-2eb8-45aa-be0b-af108804f1a8',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 12,
      yIndex: 7,
      alignment: null,
    },
    {
      id: '457c129c-8048-4c99-aced-d71fc503b26b',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 7,
      yIndex: 6,
      alignment: null,
    },
    {
      id: 'ef7af308-c35d-48b1-a5a2-350f26d05f41',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 12,
      yIndex: 2,
      alignment: null,
    },
    {
      id: 'e3eac804-7616-431f-a2af-a13c56bcea5d',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 5,
      yIndex: 7,
      alignment: null,
    },
    {
      id: 'd373ed2a-3d31-45f7-8f51-e8b8e2963851',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 6,
      yIndex: 1,
      alignment: null,
    },
    {
      id: '7ec44b94-1d9d-438f-8a0b-cc0d4a9df794',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 4,
      yIndex: 7,
      alignment: null,
    },
    {
      id: '7aa7a2b7-d6ae-41f2-9b5b-b89baa371bc2',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 3,
      yIndex: 4,
      alignment: null,
    },
    {
      id: '6601db8b-3626-4280-8045-5f17659243d9',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 6,
      yIndex: 8,
      alignment: null,
    },
    {
      id: 'be3cb4d8-cbe4-42ef-968b-b68b4910d841',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 4,
      yIndex: 6,
      alignment: null,
    },
    {
      id: '56adcc33-d229-4797-9164-d4af36f51cfc',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 10,
      yIndex: 5,
      alignment: null,
    },
    {
      id: '691915b4-7435-4252-b04f-73f74a61ac43',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 8,
      yIndex: 3,
      alignment: null,
    },
    {
      id: '78390157-ebd2-4ea9-8d21-07c986cdb5b4',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 6,
      yIndex: 0,
      alignment: null,
    },
    {
      id: '0229f4d6-1759-47cb-b108-d223f6fe9e37',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 5,
      yIndex: 6,
      alignment: null,
    },
    {
      id: '157b3095-eee4-47c1-8361-c6e33889c50f',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 3,
      yIndex: 5,
      alignment: null,
    },
    {
      id: 'cecbf964-4ead-4dbd-976a-4d1fd72294f1',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 4,
      yIndex: 10,
      alignment: null,
    },
    {
      id: '9f32c490-8469-477c-ab9a-0e1d789e94b0',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 0,
      yIndex: 8,
      alignment: null,
    },
    {
      id: '440c3d00-40f7-4314-a72e-e6edded9a06c',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 1,
      yIndex: 3,
      alignment: null,
    },
    {
      id: 'e6fa23e6-a472-4f9f-a940-0c36281ff3dc',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 2,
      yIndex: 0,
      alignment: null,
    },
    {
      id: 'e06c54ba-5e98-4b39-a97e-34269bd54fd2',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 12,
      yIndex: 4,
      alignment: null,
    },
    {
      id: 'eca8f9f1-c731-48c2-9ee1-0e95cf4ddaa1',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 0,
      yIndex: 2,
      alignment: null,
    },
    {
      id: 'a89a40d0-1e83-4e40-b2ed-12aed86222c6',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 5,
      yIndex: 9,
      alignment: null,
    },
    {
      id: '496ea7aa-490f-4740-aae3-19fd850f413a',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 4,
      yIndex: 3,
      alignment: null,
    },
    {
      id: 'f941ca90-c27a-404f-86ea-87ee2e70613b',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 1,
      yIndex: 0,
      alignment: null,
    },
    {
      id: 'c710ade3-bdd0-4f29-a131-3856a87d5411',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 5,
      yIndex: 1,
      alignment: null,
    },
    {
      id: 'cfe93a09-935f-485b-b222-535802fb3ada',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 9,
      yIndex: 3,
      alignment: null,
    },
    {
      id: '88afe960-113e-4383-bb2c-2ea33d295343',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 0,
      yIndex: 3,
      alignment: null,
    },
    {
      id: '3e10900f-f9cd-4ec2-b23c-78bc1802400c',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 1,
      yIndex: 6,
      alignment: null,
    },
    {
      id: '3fd17228-a780-46a5-bf25-31ed0228a6a8',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 0,
      yIndex: 6,
      alignment: null,
    },
    {
      id: 'd7e75ff9-dd1d-4c57-b821-25792d5c71b5',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 9,
      yIndex: 5,
      alignment: null,
    },
    {
      id: 'd211070b-9a98-496d-bdf8-23d8964d02be',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 8,
      yIndex: 6,
      alignment: null,
    },
    {
      id: 'b6bfe0fd-e4a0-48c0-98b4-45d7b0faf762',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 1,
      yIndex: 8,
      alignment: null,
    },
    {
      id: '788ae625-e04b-402f-a009-0b94037fd6ff',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 10,
      yIndex: 9,
      alignment: null,
    },
    {
      id: '697ceacf-7222-4204-8b47-53a4dba83fa0',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 12,
      yIndex: 9,
      alignment: null,
    },
    {
      id: 'ec2096f1-4961-45f0-90b4-a71fd98b8808',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 5,
      yIndex: 2,
      alignment: null,
    },
    {
      id: 'f82503ed-a6b4-4b9d-846f-b2934f138334',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 5,
      yIndex: 0,
      alignment: null,
    },
    {
      id: 'fad754e8-4d0a-4299-8e72-1d945f0a7f60',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 11,
      yIndex: 10,
      alignment: null,
    },
    {
      id: '6cb7697f-cc58-47b1-bdc1-91a9c2087fd2',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 8,
      yIndex: 5,
      alignment: null,
    },
    {
      id: '486746b8-60cb-409c-9fc3-83b824addcf7',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 7,
      yIndex: 1,
      alignment: null,
    },
    {
      id: '7c01ebf3-7ec6-4833-8fb7-0f5b0c9ad77e',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 8,
      yIndex: 8,
      alignment: null,
    },
    {
      id: '9e7dbbab-7fc3-460a-a8d3-969e110640fa',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 12,
      yIndex: 3,
      alignment: null,
    },
    {
      id: 'bde3e246-5d1d-4bb4-8e48-fe51df9b25c9',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 10,
      yIndex: 6,
      alignment: null,
    },
    {
      id: '204130c8-b00c-44bc-9c3c-d8a2910f310f',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 7,
      yIndex: 10,
      alignment: null,
    },
    {
      id: '052b2e44-89cb-400f-a48a-36cb78741458',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 8,
      yIndex: 2,
      alignment: null,
    },
    {
      id: '6dca93ed-19a2-4c77-b905-c70a6e372546',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 2,
      yIndex: 9,
      alignment: null,
    },
    {
      id: '08bbfbea-6a0a-498e-9e72-5e00a38e2567',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 11,
      yIndex: 2,
      alignment: null,
    },
    {
      id: '1930f1b4-1cd7-4c97-8845-eca033ab905f',
      type: 'SINGLE',
      parentId: '75769d63-4b5d-4da1-a79e-45ac5371d62c',
      name: 'perforatedPanelGrid',
      xIndex: 4,
      yIndex: 5,
      alignment: null,
    },
  ],
  requiredConnectArticles: [],
  requiredLightingArticles: [],
  rootArticleName: 'mLevel workstation 1500mm',
  socketType: 'F',
  theme: {
    primaryColor: 'RAL 7035',
    secondaryColor: 'RAL 7016',
  },
  version: 5,
};
